var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertySale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "#3176BC",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01685 9.91455C6.65685 9.91455 6.33285 9.85283 6.04485 9.7294C5.75685 9.60083 5.53057 9.42083 5.366 9.1894C5.20143 8.95797 5.11914 8.68797 5.11914 8.3794H6.06028C6.08086 8.61083 6.17086 8.80112 6.33028 8.95026C6.49486 9.0994 6.72371 9.17397 7.01685 9.17397C7.32028 9.17397 7.55685 9.10197 7.72657 8.95797C7.89628 8.80883 7.98114 8.61854 7.98114 8.38712C7.98114 8.20712 7.92714 8.06054 7.81914 7.9474C7.71628 7.83426 7.58514 7.74683 7.42571 7.68512C7.27143 7.6234 7.05543 7.55654 6.77771 7.48454C6.428 7.39197 6.14257 7.2994 5.92143 7.20683C5.70543 7.10912 5.52028 6.95997 5.366 6.7594C5.21171 6.55883 5.13457 6.2914 5.13457 5.95712C5.13457 5.64854 5.21171 5.37854 5.366 5.14712C5.52028 4.91569 5.73628 4.73826 6.014 4.61483C6.29171 4.4914 6.61314 4.42969 6.97828 4.42969C7.49771 4.42969 7.922 4.56083 8.25114 4.82312C8.58543 5.08026 8.77057 5.43512 8.80657 5.88769H7.83457C7.81914 5.69226 7.72657 5.52512 7.55685 5.38626C7.38714 5.2474 7.16343 5.17797 6.88571 5.17797C6.63371 5.17797 6.428 5.24226 6.26857 5.37083C6.10914 5.4994 6.02943 5.68454 6.02943 5.92626C6.02943 6.09083 6.07828 6.22712 6.176 6.33512C6.27885 6.43797 6.40743 6.52026 6.56171 6.58197C6.716 6.64369 6.92686 6.71054 7.19428 6.78254C7.54914 6.88026 7.83714 6.97797 8.05828 7.07569C8.28457 7.1734 8.47486 7.32512 8.62914 7.53083C8.78857 7.7314 8.86828 8.0014 8.86828 8.34083C8.86828 8.6134 8.79371 8.87054 8.64457 9.11226C8.50057 9.35397 8.28714 9.5494 8.00428 9.69854C7.72657 9.84254 7.39743 9.91455 7.01685 9.91455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertySale);
export default __webpack_public_path__ + "static/media/Property-Sale.a925f638ec4c537bd323cb87eb282301.svg";
export { ForwardRef as ReactComponent };